type ResultError<D = unknown> = {
	message: string;
	cause?: unknown;
	stack?: string | null;
	data?: D;
};

type ResultOk<T> = { data: T; error: null; _symbol: symbol };

type ResultErr<E extends ResultError> = {
	data: null;
	error: E;
	_symbol: symbol;
};

type Result<T, E extends ResultError = ResultError> =
	| (ResultErr<E> & { success: false })
	| (ResultOk<T> & { success: true });

const _resultSymbol = Symbol("result");

function isInstanceOfResult<T, E extends ResultError>(
	result: unknown,
): result is Result<T, E> {
	return (result as Result<T, E>)?._symbol === _resultSymbol;
}

function err<D = unknown>(error: ResultError<D>) {
	return { data: null, error, success: false as const, _symbol: _resultSymbol };
}

function ok<T>(data: T) {
	return { data, error: null, success: true as const, _symbol: _resultSymbol };
}

export {
	_resultSymbol,
	isInstanceOfResult,
	err,
	ok,
	type ResultOk,
	type ResultErr,
	type Result,
	type ResultError,
};
